document.querySelectorAll('.menu-item-has-megamenu, .menu-item-has-children').forEach(function(item) {
  // On mouse enter or keyboard focus
  item.addEventListener('mouseenter', function() {
    item.setAttribute('aria-expanded', 'true');
  });

  item.addEventListener('focusin', function() {
    item.setAttribute('aria-expanded', 'true');
  });

  // On mouse leave
  item.addEventListener('mouseleave', function() {
    item.setAttribute('aria-expanded', 'false');
  });

  // On keyboard focus out (tabbing out)
  item.addEventListener('focusout', function(e) {
    // Only collapse if focus is leaving the entire menu item
    if (!item.contains(e.relatedTarget)) {
      item.setAttribute('aria-expanded', 'false');
    }
  });
});
